/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Order_Publish_TitleInputs */



/**
* | output |
* | --- |
* | "Work Order Publish" |
*
* @param {Work_Order_Publish_TitleInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const work_order_publish_title = /** @type {((inputs?: Work_Order_Publish_TitleInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Order_Publish_TitleInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Publication de l’ordre de travail")
	if (locale === "de") return /** @type {LocalizedString} */ ("Arbeitsauftrag veröffentlichen")
	if (locale === "it") return /** @type {LocalizedString} */ ("Pubblicazione dell'ordine di lavoro")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Опубликовать заявку на выполнение работ")
	if (locale === "es") return /** @type {LocalizedString} */ ("Publicación de órdenes de trabajo")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("发布工单")
	if (locale === "ja") return /** @type {LocalizedString} */ ("作業指示書の公開")
	if (locale === "hi") return /** @type {LocalizedString} */ ("कार्य आदेश प्रकाशित करें")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("Publicação da Ordem de Serviço")
	return /** @type {LocalizedString} */ ("Work Order Publish")
});